exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-top[data-v-48acdf90]{top:-.65rem}.text-top[data-v-48acdf90]{top:-.5rem}", ""]);

// exports
